<app-block-space layout="after-header"></app-block-space>

<div class="block">
    <div class="container container--max--lg">
        <div class="row">
            <div class="col-md-3">

            </div>
            <div class="col-md-6 d-flex">
                <div class="card flex-grow-1 mb-md-0 mr-0 mr-lg-3 ml-0 ml-lg-4">
                    <div class="card-body card-body--padding--2">
                        <h3 class="card-title">{{ 'HEADER_LOGIN'|translate }}</h3>
                        <form [formGroup]="loginForm">
                            <div *ngIf="loginForm.errors?.server" class="alert alert-sm alert-danger">
                                {{ loginForm.errors.server|translate }}
                            </div>
                            <div class="form-group" *ngIf="!showForm">
                                <label for="signin-email">Enter Your Phone Number</label>
                                <input
                                    id="signin-email"
                                    type="number"
                                    class="form-control"
                                    [class.is-invalid]="loginForm.controls.phone|isInvalid"
                                    placeholder="Enter Your Phone Number"
                                    formControlName="phone"
                                >
                                <div class="invalid-feedback">
                                    <div *ngIf="loginForm.controls.phone|hasError:'required'">
                                        {{ 'ERROR_FORM_REQUIRED'|translate }}
                                    </div>

                                </div>
                            </div>
                            <div class="form-group" *ngIf="showForm">
                                <label for="signin-email">Enter OTP</label>
                                <input
                                    id="signin-email"
                                    type="number"
                                    class="form-control"
                                    placeholder="Enter OTP"
                                    formControlName="otp"
                                    required
                                >
                                <div class="invalid-feedback">
                                    <div *ngIf="showError">
                                        OTP is required
                                    </div>
                                </div>
                                <small class="form-text text-muted">
                                    <button class="btn btn-primary" (click)="resendOTP()">Resend OTP?</button>
                                </small>

                            </div>

                            <!-- <div class="form-group">
                                <label for="signin-password">{{ 'INPUT_PASSWORD_LABEL'|translate }}</label>
                                <input
                                    id="signin-password"
                                    type="password"
                                    class="form-control"
                                    [class.is-invalid]="loginForm.controls.password|isInvalid"
                                    [placeholder]="'INPUT_PASSWORD_PLACEHOLDER'|translate"
                                    formControlName="password"
                                >
                                <div class="invalid-feedback">
                                    <div *ngIf="loginForm.controls.password|hasError:'required'">
                                        {{ 'ERROR_FORM_REQUIRED'|translate }}
                                    </div>
                                </div>
                                <small class="form-text text-muted">
                                    <a routerLink="/">{{ 'LINK_FORGOT_PASSWORD'|translate }}</a>
                                </small>
                            </div> -->
                            <!-- <div class="form-group">
                                <div class="form-check">
                                    <app-checkbox
                                        class="form-check-input"
                                        formControlName="remember"
                                        #cbSignInRemember="appCheckbox"
                                    ></app-checkbox>
                                    <label class="form-check-label" [htmlFor]="cbSignInRemember.inputId">
                                        {{ 'INPUT_REMEMBER_ME_LABEL'|translate }}
                                    </label>
                                </div>
                            </div> -->
                            <div class="form-group mb-0">
                                <button
                                    type="submit"
                                    class="btn btn-primary mt-3"
                                    [class.btn-loading]="loginInProgress"
                                    (click)="login(loginForm.value)"
                                >
                                    {{ value }}
                                </button>


                            </div>

                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-3">

            </div>
            <!-- <div class="col-md-6 d-flex mt-4 mt-md-0">
                <div class="card flex-grow-1 mb-0 ml-0 ml-lg-3 mr-0 mr-lg-4">
                    <div class="card-body card-body--padding--2">
                        <h3 class="card-title">{{ 'HEADER_REGISTER'|translate }}</h3>
                        <form [formGroup]="registerForm">
                            <div *ngIf="registerForm.errors?.server" class="alert alert-sm alert-danger">
                                {{ registerForm.errors.server|translate }}
                            </div>
                            <div class="form-group">
                                <label for="signup-email">{{ 'INPUT_EMAIL_ADDRESS_LABEL'|translate }}</label>
                                <input
                                    id="signup-email"
                                    type="email"
                                    class="form-control"
                                    [class.is-invalid]="registerForm.controls.email|isInvalid"
                                    placeholder="customer@example.com"
                                    formControlName="email"
                                >
                                <div class="invalid-feedback">
                                    <div *ngIf="registerForm.controls.email|hasError:'required'">
                                        {{ 'ERROR_FORM_REQUIRED'|translate }}
                                    </div>
                                    <div *ngIf="registerForm.controls.email|hasError:'email'">
                                        {{ 'ERROR_FORM_INCORRECT_EMAIL'|translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="signup-password">{{ 'INPUT_PASSWORD_LABEL'|translate }}</label>
                                <input
                                    id="signup-password"
                                    type="password"
                                    class="form-control"
                                    [class.is-invalid]="registerForm.controls.password|isInvalid"
                                    [placeholder]="'INPUT_PASSWORD_PLACEHOLDER'|translate"
                                    formControlName="password"
                                >
                                <div class="invalid-feedback">
                                    <div *ngIf="registerForm.controls.password|hasError:'required'">
                                        {{ 'ERROR_FORM_REQUIRED'|translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="signup-confirm">{{ 'INPUT_PASSWORD_REPEAT_LABEL'|translate }}</label>
                                <input
                                    id="signup-confirm"
                                    type="password"
                                    class="form-control"
                                    [class.is-invalid]="registerForm.controls.confirmPassword|isInvalid"
                                    [placeholder]="'INPUT_PASSWORD_REPEAT_PLACEHOLDER'|translate"
                                    formControlName="confirmPassword"
                                >
                                <div class="invalid-feedback">
                                    <div *ngIf="registerForm.controls.confirmPassword|hasError:'required'">
                                        {{ 'ERROR_FORM_REQUIRED'|translate }}
                                    </div>
                                    <div *ngIf="registerForm.controls.confirmPassword|hasError:'mustMatch'">
                                        {{ 'ERROR_FORM_PASSWORD_DOES_NOT_MATCH'|translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mb-0">
                                <button
                                    type="submit"
                                    class="btn btn-primary mt-3"
                                    [class.btn-loading]="registerInProgress"
                                    (click)="register()"
                                >
                                    {{ 'BUTTON_REGISTER'|translate }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>

<app-block-space layout="before-footer"></app-block-space>
